<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    teamForBroker: boolean;
    size?: number | string;
    color?: string;
  }>(),
  {
    size: "small",
    color: "",
  },
);
</script>

<template>
  <div v-if="props.teamForBroker">
    <v-tooltip location="top">
      <template #activator="{ props: tooltipProps }">
        <v-icon :color="props.color" :size="props.size" v-bind="tooltipProps">mdi-account-multiple</v-icon>
      </template>
      Team for broker
    </v-tooltip>
  </div>
</template>
